/** @jsx isolateComponent */

import { Button, Spacer, Text } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { Plan } from '@zapier/upsells/src/types';

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: 600,
    textAlign: 'center' as 'center',
  },
};

const distillPlanFeatures = ({ premiumAppsLimit, tasks, zapLimit }: Plan) => {
  const premiumAppsText =
    premiumAppsLimit === -1
      ? 'unlimited Premium Apps'
      : `${Number(premiumAppsLimit).toLocaleString()} Premium Apps`;

  const zapsText =
    zapLimit === -1
      ? 'unlimited Zaps'
      : `${Number(zapLimit).toLocaleString()} Zaps`;

  const tasksText = `${Number(tasks).toLocaleString()} tasks`;

  return `${premiumAppsText}, ${zapsText}, and ${tasksText}!`;
};

const contentMap = {
  TRIAL: () => ({
    bodyText: `You are now experiencing the Zapier Professional Plan free for the next 7 days! Take advantage of unlimited Premium apps, unlimited Zaps, and ${Number(
      1000
    ).toLocaleString()} tasks!`,
    headingText: `Free Trial Started`,
  }),

  UPGRADE: (newPlan: Plan | undefined) => ({
    bodyText: newPlan
      ? `You just upgraded to the Zapier ${
          newPlan.name
        } Plan. Take advantage of ${distillPlanFeatures(newPlan)}`
      : 'You just upgraded to a new Zapier plan.', // This should theoretically never happen, but just in case.
    headingText: `Account Upgraded!`,
  }),
};

type Props = {
  buttonText: string;
  newPlan?: Plan;
  onClose: () => void;
  celebrationType: 'trial' | 'upgrade';
};

export const Celebrate = ({
  buttonText,
  celebrationType,
  newPlan,
  onClose,
}: Props) => {
  const content =
    celebrationType === 'trial'
      ? contentMap.TRIAL()
      : contentMap.UPGRADE(newPlan);

  return (
    <div css={styles.container}>
      <Text tag="h1" type="subHeader1Bold">
        {content.headingText}
      </Text>

      <Spacer height={20} />

      <Text color="gray60" tag="p" type="bodyText800">
        {content.bodyText}
      </Text>

      <Spacer height={30} />

      <Button hasShadow={true} onClick={onClose}>
        {buttonText}
      </Button>
    </div>
  );
};
